import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-promotion-v2',
  templateUrl: './promotion-v2.component.html',
  styleUrls: ['./promotion-v2.component.css']
})
export class PromotionV2Component implements OnInit {
  ngOnInit() { }
}
